var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIconFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12057_4059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5066 4.81415C29.6144 1.49728 23.8258 2.09389 20.2533 5.7801L18.8541 7.22191L17.4549 5.7801C13.8894 2.09389 8.09377 1.49728 4.2016 4.81415C-0.258781 8.6211 -0.493164 15.4537 3.49845 19.5803L17.2418 33.7711C18.1296 34.6873 19.5714 34.6873 20.4592 33.7711L34.2026 19.5803C38.2013 15.4537 37.9669 8.6211 33.5066 4.81415Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12057_4059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.3649,
    height: 36.3649,
    fill: "white",
    transform: "translate(0.672302 0.368256)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconFill);
export default __webpack_public_path__ + "static/media/heart-icon-fill.8706e186c2ffe1d02faa645fa5c49f8a.svg";
export { ForwardRef as ReactComponent };